import { render } from "./ForecastMonthlyDetail.vue?vue&type=template&id=40863230"
import script from "./ForecastMonthlyDetail.vue?vue&type=script&lang=js"
export * from "./ForecastMonthlyDetail.vue?vue&type=script&lang=js"
script.render = render

export default script